module.exports = __webpack_public_path__ + "img/load_boat.a93e1eaf.png";